import api from './index';
import type { Employee } from './Employee';
import type { Provider } from './provedor';
import type { Vehicle } from './vehicles';

export type FuelingStatus =
  | 'blocked'
  | 'aprovado'
  | 'rejeitado'
  | 'finalizado';

export interface Fueling {
  id: number;
  vehicle_id: number;
  employee_id: number;
  provider_id: number;
  fuel_type: string;
  amount: number;
  cost_per_liter: number;
  total_cost: number;
  odometer_reading?: number;
  fueling_time?: string;
  invoice_number?: string;
  notes?: string;
  created_at: string;
  updated_at: string;
  status?: FuelingStatus;
  boleto_photo?: { url: string } | string | null;
  vehicle?: Vehicle;
  employee?: Employee;
  provider?: Provider;
  archived?: boolean;
}

export type CreateFuelingData = Omit<Fueling, 'id' | 'created_at' | 'updated_at'>;
export type UpdateFuelingData = Partial<CreateFuelingData>;

const baseUrl = '/fuelings';

export const fuelingService = {
  async getAllFuelings(): Promise<Fueling[]> {
    const response = await api.get(baseUrl);
    return response.data;
  },

  async getFuelingById(id: number): Promise<Fueling> {
    const response = await api.get(`${baseUrl}/${id}`);
    return response.data;
  },

  async createFueling(data: CreateFuelingData): Promise<Fueling> {
    const response = await api.post(baseUrl, data);
    return response.data;
  },

  async updateFueling(id: number, data: UpdateFuelingData): Promise<Fueling> {
    const response = await api.put(`${baseUrl}/${id}`, data);
    return response.data;
  },

  async deleteFueling(id: number): Promise<void> {
    await api.delete(`${baseUrl}/${id}`);
  },
};
